import script from "./ClosedList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClosedList.vue?vue&type=script&lang=ts&setup=true"

import "./ClosedList.vue?vue&type=style&index=0&id=7620d402&lang=scss"

const __exports__ = script;

export default __exports__